import { render } from "./FabTranslationSelector.vue?vue&type=template&id=142b7b07"
import script from "./FabTranslationSelector.vue?vue&type=script&lang=js"
export * from "./FabTranslationSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__